import { render } from "./DesignerBar.vue?vue&type=template&id=c6ec13b0&scoped=true"
import script from "./DesignerBar.vue?vue&type=script&lang=js"
export * from "./DesignerBar.vue?vue&type=script&lang=js"

import "./DesignerBar.vue?vue&type=style&index=0&id=c6ec13b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c6ec13b0"

export default script